import * as messageAlert from '../../../../actions/messageAlertAction';
import { I18n } from 'react-redux-i18n-lite';
import * as React from 'react';
import PropTypes from 'prop-types';
import { TopRowIcons } from './topRowIcons/TopRowIcons';
import { GradeStudentRow } from './gradeStudentRow/GradeStudentRow';
import { findDOMNode } from 'react-dom';
import { CMI5 } from '../../../../const';
import * as activityService from '../../../../services/domain/activityService';
import { bindActionCreators } from 'redux';
import * as bookActions from '../../../../actions/bookActions';
import * as gradebookActions from '../../../../actions/classroom/gradebookActions';
import { connect } from 'react-redux';
import CustomIcon from '../../../common/CustomIcon';
import * as analyticsApi from '../../../../services/api/analyticsApi';
import { ANALYTICS_CONTEXT, ANALYTICS_EVENT } from '../../../../types/analytics';
import AssessableCheckbox from './AssessableCheckbox';
import SmartPopover from '../../../common/smartPopover/SmartPopover';
import { ScrollToTop } from '@netexknowledge/smart-components';
import * as accountActions from '../../../../actions/accountActions';
import { isMobileViewport } from '../../../../utils/mobileUtils';
import { loadGradebookBook, openGradebookContent } from '../../openGradebookContent';
class GradesList extends React.Component {
  AssessableStates = Object.freeze({
    UNCHANGED: Symbol('unchanged'),
    UNSAVED: Symbol('unsaved'),
    SAVING: Symbol('saving')
  });

  constructor(props) {
    super(props);
    this.infoNode = React.createRef();
    this.state = {
      mounted: false,
      maxHeight: 0,
      assessableState: this.AssessableStates.UNCHANGED,
      activitiesToSave: [],
      visibleInfo: false
    };

    this.reference = React.createRef();
  }

  componentDidMount() {
    this.setState({
      mounted: true,
      maxHeight: findDOMNode(this).clientHeight
    });
    this.preloadMobileBook();
  }

  /* * * * MOBILE SHEET (GradeStudentRow on mobile) * * * */

  // The content opens in a new tab, which mobile browsers only allow within the gesture: load the book first
  preloadMobileBook() {
    const { selectedBook, routeParams } = this.props;
    if (!isMobileViewport() || !selectedBook || !routeParams) return;
    loadGradebookBook(routeParams.idClassroom, selectedBook)
      .then(book => {
        this.mobileBook = book;
      })
      .catch(() => {
        this.mobileBook = null;
      });
  }

  // Activity of the selected lesson for a column (only lessons list their activities)
  getAssessable = item => {
    const { selectedLesson, activities } = this.props;
    return selectedLesson ? (activities || []).find(activity => activity.id === item.id) : undefined;
  };

  // Lessons of a unit go back to the book, as clearing the unit in the selector
  getLevelUpHandler = () => {
    const { gradeTypes, setSelectedUnit, sectionId, selectedBook, routeParams } = this.props;
    if (gradeTypes !== 'lesson') return undefined;
    return () => setSelectedUnit(null, sectionId, selectedBook, routeParams.idClassroom);
  };

  getOpenContentHandler = item => () => {
    const { selectedLesson, bookActions, accountActions, account, institution, classroom } = this.props;
    if (!this.mobileBook) return;
    openGradebookContent({
      book: this.mobileBook,
      lessonActivityId: selectedLesson.activityId || selectedLesson.id,
      questionActivityId: item.id,
      bookActions,
      accountActions,
      account,
      institution,
      classroom
    });
  };

  // Saves one activity right away. The grades are recalculated when the sheet closes, since reloading them
  // unmounts the rows and the sheet with them.
  saveAssessableNow = (activity, assessable) => {
    const { sectionId, bookActions, messageAlert, gradebookActions } = this.props;
    const activityToSave = { ...activity, assessable };
    const startedAt = Date.now();

    return bookActions
      .updateAssessable(sectionId, [activityToSave])
      .then(() => {
        const activities = (this.props.activities || []).map(a => (a.id === activity.id ? { ...a, assessable } : a));
        gradebookActions.setActivitiesData(activities);
        this.pendingAssessable = [...(this.pendingAssessable || []).filter(a => a.id !== activity.id), activityToSave];
        this.trackGradesSave({
          activitiesToSave: [activityToSave],
          status: 'success',
          startedAt,
          context: ANALYTICS_CONTEXT.GRADES_MOBILE_SWITCH
        });
        messageAlert.success(I18n.t('gradebook.changesSaved'));
        return true;
      })
      .catch(err => {
        this.trackGradesSave({
          activitiesToSave: [activityToSave],
          status: 'error',
          startedAt,
          context: ANALYTICS_CONTEXT.GRADES_MOBILE_SWITCH,
          errorMessage: err && err.message
        });
        messageAlert.error(I18n.t('connection.networkKO'));
        return false;
      });
  };

  onMobileSheetClose = () => {
    if (this.pendingAssessable && this.pendingAssessable.length) {
      const activitiesToSave = this.pendingAssessable;
      this.pendingAssessable = [];
      this.updateGradebookLessonData(activitiesToSave);
    }
  };

  getGroup(config) {
    let result = null;
    this.props.groups.forEach(group => {
      if (group.id === config.groups[0]) {
        result = group;
      }
    });
    return result;
  }

  getColor(config) {
    let color = 'primary';

    if (config.groups.length > 0) {
      this.props.groups.forEach(group => {
        if (group.id === config.groups[0]) {
          color = `group0${group.colour}`;
        }
      });
    }
    return `${color}`;
  }

  isAssessable = activity => {
    if (activity && activity.activityType === CMI5.ACTIVITY_TYPE.LESSON) {
      return activity.hasChildren;
    }
    return true;
  };

  renderListHeaderRow(columns) {
    const { activities } = this.props;
    let topIcons = [];

    columns.forEach((item, index) => {
      const activity = activities.find(a => a.id === item.id);

      topIcons.push(
        <div key={index}>
          {activity && <AssessableCheckbox onClick={() => this.onAssessableClick(activity)} activity={activity} />}
          <TopRowIcons
            className="margin-left"
            item={item}
            isAssessable={this.isAssessable(item)}
            routeParams={this.props.routeParams}
            icon={activityService.getActivityIcon(item.activityType)}
            group={this.getGroup(item.configuration)}
            color={this.getColor(item.configuration)}
            gradeTypes={this.props.gradeTypes}
            setSelectedBook={this.props.setSelectedBook}
            setSelectedUnit={this.props.setSelectedUnit}
            setSelectedLesson={this.props.setSelectedLesson}
            sectionId={this.props.sectionId}
          />
        </div>
      );
    });
    return topIcons;
  }

  // Mobile sheet rows of unit and lesson columns drill down, as the desktop header icons (TopRowIcons)
  getDrillHandler = item => {
    const { gradeTypes, setSelectedUnit, setSelectedLesson, sectionId } = this.props;
    if (!this.isAssessable(item)) return undefined;
    if (gradeTypes === 'unit') return () => setSelectedUnit(item, sectionId);
    if (gradeTypes === 'lesson') return () => setSelectedLesson(item, sectionId);
    return undefined;
  };

  renderStudents(columns) {
    let { grades, colors, groups, selectedUnit, selectedLesson, selectedBook, gradebookScope } = this.props;
    let studentsList = [];

    if (grades && grades.students) {
      const shouldShowStudent = (student, selectedActivity) => {
        const studentInGroup =
          (selectedActivity.configuration && selectedActivity.configuration.groups.length === 0) ||
          (selectedActivity.configuration &&
            selectedActivity.configuration.groups.length > 0 &&
            groups.find(e => e.id === selectedActivity.configuration.groups[0]) &&
            groups.find(e => e.id === selectedActivity.configuration.groups[0]).participants.includes(student.userId));
        const studentAssigned =
          (selectedActivity.configuration && selectedActivity.configuration.users.length === 0) ||
          (selectedActivity.configuration &&
            selectedActivity.configuration.users.length > 0 &&
            selectedActivity.configuration.users.includes(student.userId));

        return studentInGroup && studentAssigned;
      };
      grades.students.forEach((student, index) => {
        let showStudent = true;
        if (selectedLesson) {
          showStudent = shouldShowStudent(student, selectedLesson);
        } else if (selectedUnit) {
          showStudent = shouldShowStudent(student, selectedUnit);
        } else if (selectedBook) {
          showStudent = shouldShowStudent(student, selectedBook);
        }
        if (showStudent) {
          studentsList.push(
            <GradeStudentRow
              gradebookScope={gradebookScope}
              key={index}
              colors={colors}
              columns={columns}
              student={student}
              avatarUrl={student.avatar}
              groups={groups}
              selectedUnit={selectedUnit}
              selectedBook={selectedBook}
              selectedLesson={selectedLesson}
              getDrillHandler={this.getDrillHandler}
              getLevelUpHandler={this.getLevelUpHandler}
              getAssessable={this.getAssessable}
              getOpenContentHandler={this.getOpenContentHandler}
              onToggleAssessable={this.saveAssessableNow}
              onSheetClose={this.onMobileSheetClose}
              canEditAssessable={this.props.role === 'INSTRUCTOR'}
            />
          );
        }
      });
    }
    return studentsList;
  }

  getColumns() {
    let { items } = this.props;
    return items.filter(item => {
      let isVideo = activityService.getActivityIcon(item.activityType) === 'play-video';
      let isAudio = activityService.getActivityIcon(item.activityType) === 'audio-headphones';
      if (!isVideo && !isAudio) {
        return item;
      }
      return undefined;
    });
  }

  render() {
    const { role } = this.props;
    let columns = this.getColumns();
    return (
      <div className="grades-list">
        <div className="scrollToTop-bnt-wrapper">
          <ScrollToTop contentQuerySelector=".students-list"></ScrollToTop>
        </div>
        <div className="top-row-wrapper">
          {Boolean(this.props.activities && this.props.activities.length) && (
            <div>
              <div
                ref={this.infoNode}
                className="grades-info-icon"
                onMouseEnter={() => {
                  this.setState({ visibleInfo: true });
                }}
                onMouseLeave={() => {
                  this.setState({ visibleInfo: false });
                }}
              >
                <CustomIcon size={15} name="information-square" />
              </div>
              {this.infoNode.current && (
                <SmartPopover
                  placement={'top'}
                  node={this.infoNode.current}
                  visible={this.state.visibleInfo}
                  message={I18n.t('gradebook.assessableInfo')}
                />
              )}
            </div>
          )}
          <div className="grades-top-row">
            <span />
            {this.renderListHeaderRow(columns)}
            {Boolean(this.props.activities && this.props.activities.length) &&
              ((this.state.assessableState === this.AssessableStates.UNSAVED && (
                <div
                  className="grades-save-assessable"
                  ref={this.reference}
                  onClick={() => this.onSaveAssessableClick()}
                >
                  {role === 'INSTRUCTOR' && I18n.t('gradebook.saveChanges')}
                </div>
              )) ||
                (this.state.assessableState === this.AssessableStates.SAVING && (
                  <div className="grades-saving-assessable">{I18n.t('gradebook.savingChanges')}</div>
                )))}
          </div>
        </div>
        <div className={this.props.selectedLesson ? 'students-list students-list-lesson' : 'students-list'}>
          {this.renderStudents(columns)}
        </div>
      </div>
    );
  }

  onSaveAssessableClick() {
    const { sectionId, bookActions, messageAlert, activities } = this.props;

    this.setState({ assessableState: this.AssessableStates.SAVING });

    const activitiesToSave = activities.filter(a => this.state.activitiesToSave.includes(a.id));
    const startedAt = Date.now();

    bookActions
      .updateAssessable(sectionId, activitiesToSave)
      .then(() => {
        this.trackGradesSave({ activitiesToSave, status: 'success', startedAt });
        this.setState({ assessableState: this.AssessableStates.UNCHANGED, activitiesToSave: [] });
        this.updateGradebookLessonData(activitiesToSave);
        messageAlert.success(I18n.t('gradebook.changesSaved'));
      })
      .catch(err => {
        this.trackGradesSave({ activitiesToSave, status: 'error', startedAt, errorMessage: err && err.message });
        this.setState({ assessableState: this.AssessableStates.UNSAVED, activitiesToSave: [] });
        messageAlert.error(I18n.t('connection.networkKO'));
      });
  }

  trackGradesSave({ activitiesToSave, status, startedAt, errorMessage, context = ANALYTICS_CONTEXT.GRADES_SAVE_BUTTON }) {
    const { routeParams, selectedUnit, selectedLesson } = this.props;

    analyticsApi.trackAnalyticsEvent({
      event: ANALYTICS_EVENT.GRADES_SAVE_CHANGES,
      classId: routeParams.idClassroom,
      unitId: selectedUnit ? selectedUnit.activityId || selectedUnit.id : null,
      lessonId: selectedLesson ? selectedLesson.activityId || selectedLesson.id : null,
      assessableActivityIds: activitiesToSave.filter(a => a.assessable !== false).map(a => a.id),
      notAssessableActivityIds: activitiesToSave.filter(a => a.assessable === false).map(a => a.id),
      context,
      status,
      durationMs: Date.now() - startedAt,
      ...(errorMessage && { errorMessage })
    });
  }

  onAssessableClick(activity) {
    const { activities, gradebookActions } = this.props;

    if (!activity.disabled) {
      activity.assessable = activity.assessable === undefined ? false : Boolean(!activity.assessable);

      this.focusSaveButton();

      gradebookActions.setActivitiesData(activities);

      if (!this.state.activitiesToSave.includes(activity.id)) {
        this.setState({
          assessableState: this.AssessableStates.UNSAVED,
          activitiesToSave: [...this.state.activitiesToSave, activity.id]
        });
      }
    }
  }

  focusSaveButton = async () => {
    if (this.reference.current) {
      this.reference.current.scrollIntoView();
    } else {
      setTimeout(this.focusSaveButton, 1);
    }
  };

  updateGradebookLessonData = activitiesToSave => {
    const { selectedLesson, selectedUnit, sectionId, gradebookActions } = this.props;

    activitiesToSave.forEach(activity => {
      const auOrBlockActivity = selectedLesson.auOrBlock.find(a => a.id === activity.id);
      auOrBlockActivity.assessable = activity.assessable;
    });

    gradebookActions.setLessonData(selectedLesson, sectionId, selectedUnit);
  };
}

GradesList.propTypes = {
  colors: PropTypes.any,
  routeParams: PropTypes.any,
  groups: PropTypes.array,
  grades: PropTypes.object,
  items: PropTypes.array,
  gradeTypes: PropTypes.string,
  books: PropTypes.array,
  units: PropTypes.array,
  lessons: PropTypes.array,
  setSelectedBook: PropTypes.func,
  setSelectedUnit: PropTypes.func,
  setSelectedLesson: PropTypes.func,
  sectionId: PropTypes.string,
  bookActions: PropTypes.any,
  gradebookActions: PropTypes.any,
  activities: PropTypes.array,
  messageAlert: PropTypes.any,
  selectedLesson: PropTypes.object,
  selectedUnit: PropTypes.object,
  role: PropTypes.string,
  accountActions: PropTypes.object,
  account: PropTypes.object,
  institution: PropTypes.object,
  classroom: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(GradesList);

function mapStateToProps(state) {
  return {
    activities: state.gradebook.activities,
    account: state.account,
    institution: state.school.school,
    classroom: state.classrooms.selectedClassroom.classroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    gradebookActions: bindActionCreators(gradebookActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}
